var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6484 27.9504C29.7598 28.0619 29.8483 28.1943 29.9086 28.3399C29.9689 28.4856 30 28.6417 30 28.7994C30 28.9571 29.9689 29.1132 29.9086 29.2588C29.8483 29.4045 29.7598 29.5369 29.6484 29.6484C29.5369 29.7598 29.4045 29.8483 29.2588 29.9086C29.1132 29.9689 28.9571 30 28.7994 30C28.6417 30 28.4856 29.9689 28.3399 29.9086C28.1943 29.8483 28.0619 29.7598 27.9504 29.6484L18 19.6964L8.04955 29.6484C7.8244 29.8735 7.51902 30 7.2006 30C6.88218 30 6.5768 29.8735 6.35165 29.6484C6.12649 29.4232 6 29.1178 6 28.7994C6 28.481 6.12649 28.1756 6.35165 27.9504L16.3036 18L6.35165 8.04955C6.12649 7.8244 6 7.51902 6 7.2006C6 6.88218 6.12649 6.5768 6.35165 6.35165C6.5768 6.12649 6.88218 6 7.2006 6C7.51902 6 7.8244 6.12649 8.04955 6.35165L18 16.3036L27.9504 6.35165C28.1756 6.12649 28.481 6 28.7994 6C29.1178 6 29.4232 6.12649 29.6484 6.35165C29.8735 6.5768 30 6.88218 30 7.2006C30 7.51902 29.8735 7.8244 29.6484 8.04955L19.6964 18L29.6484 27.9504Z",
    fill: "#1E3685"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.d9315f7a31778f0aea0327e90e95c294.svg";
export { ForwardRef as ReactComponent };